import React, { useRef, useEffect } from 'react';

const AutoPause = ({ src, className = '', ...props }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            videoRef.current.play().catch(() => {});
          } else {
            videoRef.current.pause();
          }
        }
      },
      {
        threshold: 0.3,
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    const videoEl = videoRef.current;

    return () => {
      if (videoEl) {
        observer.unobserve(videoEl);
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      className={className}
      muted
      loop
      playsInline
      preload="none"
      {...props}
    >
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default AutoPause;
